// extracted by mini-css-extract-plugin
export default {"mainSectionStyle":"CSMLayout_mainSectionStyle__ssDEj","contentStyle":"CSMLayout_contentStyle__88-cj"};